import { useState } from 'react';

export enum RequestState {
  Pending = 'pending',
  Error = 'error',
  Success = 'success',
}

export function useRequestsState<T, R = any>(
  request: (payload: T) => Promise<R>
) {
  const [state, setState] = useState<{ [id: string]: RequestState }>({});

  const sendRequest = (id: number | string, payload: T) => {
    setState((prevState) => ({ ...prevState, [id]: RequestState.Pending }));
    request(payload)
      .then(() =>
        setState((prevState) => ({ ...prevState, [id]: RequestState.Success }))
      )
      .catch((err) =>
        setState((prevState) => ({ ...prevState, [id]: RequestState.Error }))
      );
  };

  return [state, sendRequest] as const;
}
